import { render, staticRenderFns } from "./Top10ChartItem.vue?vue&type=template&id=b133bfd0&scoped=true&"
import script from "./Top10ChartItem.vue?vue&type=script&lang=js&"
export * from "./Top10ChartItem.vue?vue&type=script&lang=js&"
import style0 from "./Top10ChartItem.vue?vue&type=style&index=0&id=b133bfd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b133bfd0",
  null
  
)

export default component.exports